export const fredrick = {
    id: "host_fredrick",
    tenantId: "tenant_roby",
    slug: "fred",
    displayName: "Fredrick Roby",
    defaultTimeZone: "America/Los_Angeles",
    roles: ["platform_admin", "host"]
};
export const personas = [
    {
        id: "persona_amazon",
        hostId: fredrick.id,
        slug: "amazon",
        name: "Amazon professional",
        displayName: "Fredrick Roby",
        headline: "Product and technology conversations",
        organization: "Amazon",
        bio: "Book focused time for program reviews, partner syncs, mentoring, and follow-up discussions.",
        accentColor: "#146eb4",
        defaultTimeZone: "America/Los_Angeles",
        locationPreference: { kind: "microsoft_teams" },
        publicState: "active",
        confirmationCopy: "Your time with Fredrick is confirmed.",
        cancellationCopy: "This meeting has been canceled."
    },
    {
        id: "persona_fms",
        hostId: fredrick.id,
        slug: "fundmysquad",
        name: "Fund My Squad founder",
        displayName: "Fredrick Roby",
        headline: "Fundraising strategy and squad growth",
        organization: "Fund My Squad",
        bio: "Choose a slot for fundraising planning, partner introductions, or platform onboarding.",
        accentColor: "#0f766e",
        defaultTimeZone: "America/Los_Angeles",
        locationPreference: { kind: "google_meet" },
        publicState: "active",
        confirmationCopy: "Your Fund My Squad meeting is confirmed.",
        cancellationCopy: "Your Fund My Squad meeting has been canceled."
    },
    {
        id: "persona_personal",
        hostId: fredrick.id,
        slug: "personal",
        name: "Personal",
        displayName: "Fredrick Roby",
        headline: "Family, community, and personal appointments",
        bio: "Private-link scheduling for personal commitments.",
        accentColor: "#7c3aed",
        defaultTimeZone: "America/Los_Angeles",
        locationPreference: { kind: "phone", instructions: "Fredrick will call the number provided." },
        publicState: "private_link",
        confirmationCopy: "Your appointment is confirmed.",
        cancellationCopy: "This appointment has been canceled."
    }
];
export const meetingTypes = [
    {
        id: "meeting_intro",
        personaId: "persona_fms",
        slug: "intro",
        title: "Fundraising intro",
        description: "A 30-minute call to understand goals, timeline, and next steps.",
        active: true,
        durationMinutes: 30,
        slotIntervalMinutes: 15,
        minimumNoticeMinutes: 120,
        horizonDays: 21,
        preBufferMinutes: 10,
        postBufferMinutes: 10,
        maxBookingsPerDay: 6,
        availability: weekdayWindows(9 * 60, 16 * 60),
        requiredFields: ["name", "email", "organization", "reason"]
    },
    {
        id: "meeting_work_sync",
        personaId: "persona_amazon",
        slug: "sync",
        title: "Work sync",
        description: "A focused 25-minute professional sync.",
        active: true,
        durationMinutes: 25,
        slotIntervalMinutes: 15,
        minimumNoticeMinutes: 240,
        horizonDays: 14,
        preBufferMinutes: 5,
        postBufferMinutes: 5,
        availability: weekdayWindows(10 * 60, 15 * 60),
        requiredFields: ["name", "email", "reason"]
    }
];
export const calendarConnections = [
    {
        id: "conn_google",
        hostId: fredrick.id,
        provider: "google",
        label: "Google Calendar",
        status: "connected",
        grantedScopes: ["calendar.freebusy", "calendar.events"],
        lastSuccessfulCheck: "2026-09-02T15:00:00.000Z"
    },
    {
        id: "conn_microsoft",
        hostId: fredrick.id,
        provider: "microsoft",
        label: "Microsoft 365",
        status: "needs_reconnect",
        grantedScopes: ["Calendars.Read", "Calendars.ReadWrite"]
    },
    {
        id: "conn_zoho",
        hostId: fredrick.id,
        provider: "zoho",
        label: "Zoho Calendar",
        status: "connected",
        grantedScopes: ["ZohoCalendar.calendar.READ", "ZohoCalendar.event.CREATE"],
        lastSuccessfulCheck: "2026-09-02T14:45:00.000Z"
    }
];
export const calendarResources = [
    {
        id: "cal_google_primary",
        connectionId: "conn_google",
        providerCalendarId: "primary",
        label: "Google primary",
        blocksAvailability: true,
        destinationPriority: 1,
        busyDefaults: safeBusyDefaults()
    },
    {
        id: "cal_ms_work",
        connectionId: "conn_microsoft",
        providerCalendarId: "calendar",
        label: "Work calendar",
        blocksAvailability: true,
        destinationPriority: 2,
        busyDefaults: safeBusyDefaults()
    },
    {
        id: "cal_zoho_founder",
        connectionId: "conn_zoho",
        providerCalendarId: "founder",
        label: "Founder calendar",
        blocksAvailability: true,
        destinationPriority: 3,
        busyDefaults: safeBusyDefaults()
    }
];
export const mockBusyIntervals = [
    { start: "2026-09-03T17:00:00.000Z", end: "2026-09-03T18:00:00.000Z" },
    { start: "2026-09-03T20:30:00.000Z", end: "2026-09-03T21:30:00.000Z" },
    { start: "2026-09-04T16:00:00.000Z", end: "2026-09-04T19:00:00.000Z" }
];
export const mockBookings = [
    {
        id: "booking_confirmed_1",
        tenantId: fredrick.tenantId,
        hostId: fredrick.id,
        personaId: "persona_fms",
        meetingTypeId: "meeting_intro",
        guestName: "Taylor Morgan",
        guestEmail: "taylor@example.com",
        interval: { start: "2026-09-03T19:00:00.000Z", end: "2026-09-03T19:30:00.000Z" },
        status: "confirmed",
        destinationProvider: "google",
        externalEventId: "mock-google-1",
        idempotencyKey: "seed-1",
        createdAt: "2026-09-01T18:00:00.000Z",
        updatedAt: "2026-09-01T18:00:00.000Z"
    }
];
function weekdayWindows(startMinute, endMinute) {
    return [1, 2, 3, 4, 5].map((dayOfWeek) => ({
        dayOfWeek,
        startMinute,
        endMinute,
        timeZone: "America/Los_Angeles"
    }));
}
function safeBusyDefaults() {
    return {
        tentativeBlocks: true,
        outOfOfficeBlocks: true,
        workingElsewhereBlocks: true,
        declinedBlocks: false,
        allDayBlocks: true,
        focusTimeBlocks: true,
        privateDetailsVisibleToHost: false
    };
}
